export default class Button extends Phaser.GameObjects.Container {
    public heroId: number;
    private sprite!: Phaser.GameObjects.Image;
    private selected: boolean = false;

    constructor(scene: Phaser.Scene, x: number, y: number, heroId: number) {
        super(scene, x, y);

        this.heroId = heroId;
        if (this.heroId === 0) this.selected = true;

        this.setupSprite();
    }

    private setupSprite(): void {
        const frame = this.heroId === 0 ? 'gui/selector/alice_on' : 'gui/selector/bob_off';

        this.sprite = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.sprite);

        this.sprite.setInteractive({ useHandCursor: true });
        this.sprite.on('pointerdown', () => {
            if (!this.selected) this.emit('click', this);
        });
    }

    public select(): void {
        if (this.selected) return;
        this.selected = true;

        const frame = this.heroId === 0 ? 'gui/selector/alice_on' : 'gui/selector/bob_on';
        this.sprite.setFrame(frame);
    }

    public deselect(): void {
        this.selected = false;

        const frame = this.heroId === 0 ? 'gui/selector/alice_off' : 'gui/selector/bob_off';
        this.sprite.setFrame(frame);
    }
}
